export interface PepLinkOptions {
  utm_source?: string;
  utm_medium?: string;
  email?: string;
  company?: string;
}

export function buildPepProductTrialUrl(
  pepBaseUrl: string,
  moduleId: string,
  options: PepLinkOptions = {}
): string {
  try {
    const base = (pepBaseUrl || "http://localhost:3101").replace(/\/$/, "");
    const url = new URL(`${base}/trial`);
    url.searchParams.set("product", moduleId);
    url.searchParams.set("utm_source", options.utm_source ?? "itaas");
    url.searchParams.set("utm_medium", options.utm_medium ?? "cross_sell");
    if (options.email) url.searchParams.set("email", options.email);
    if (options.company) url.searchParams.set("company", options.company);
    return url.toString();
  } catch {
    return `#trial-${moduleId}`;
  }
}

export function buildPepCatalogUrl(pepBaseUrl: string): string {
  const base = (pepBaseUrl || "http://localhost:3101").replace(/\/$/, "");
  return `${base}/products`;
}

export function buildPepContactUrl(pepBaseUrl: string): string {
  const base = (pepBaseUrl || "http://localhost:3101").replace(/\/$/, "");
  return `${base}/contact`;
}
